<template>
	<el-row class="points-show">
		<el-col :span="23">
			课程管理
		</el-col>
		<el-divider></el-divider>
		<el-row :gutter="20">
			<el-col :span="5">
				<div class="search-view">
					<div>课程名称：</div>
					<el-input size="mini" placeholder="请课程名称" v-model="coursename" clearable />
				</div>
			</el-col>
			<el-col :span="5">
				<div class="search-view">
					<div>关联品类：</div>
					<el-select filterable size="mini" v-model="category" placeholder="请选择关联品类">
						<el-option v-for="item in matVarietyList" :key="item.dicId" :label="item.dicDesc"
							:value="item.dicId">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :span="5">
				<div class="search-view">
					<div>课程状态：</div>
					<el-select v-model="status" size="mini" clearable placeholder="请选择">
						<el-option v-for="item in classStatus" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :span="5">
				<el-button type="primary" size="mini" @click="handleSizeChange()">查询</el-button>
				<el-button type="success" size="mini" icon="el-icon-plus" @click="switchDialog('classForm')">增加
				</el-button>
			</el-col>
		</el-row>
		<el-col :span="24">
			<!-- 数据列表 -->
			<el-table :data="classData" style="width: 100%" :height="tableHeight">
				<el-table-column prop="courseId" label="课程id" width="65"> </el-table-column>
				<el-table-column prop="courseName" label="课程标题" width="180"> </el-table-column>
				<el-table-column prop="themePic" label="主题图片">
					<template slot-scope="scope">
						<img style="width: 90px;" :src="scope.row.themePic" />
					</template>
				</el-table-column>
				<el-table-column prop="customerStageName" label="课程阶段"> </el-table-column>
				<el-table-column label="标签管理">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="editClassAdditionalMsg(scope.row,'dicForm')"
							icon="el-icon-edit" circle></el-button>
					</template>
				</el-table-column>
				<el-table-column label="分组标签管理">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="editClassAdditionalMsg(scope.row,'groupDicForm')"
							icon="el-icon-milk-tea" circle></el-button>
					</template>
				</el-table-column>
				<el-table-column label="扩充标识管理">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="editClassAdditionalMsg(scope.row,'kcLabelForm')"
							icon="el-icon-pear" circle></el-button>
					</template>
				</el-table-column>
				<el-table-column label="扩充标签管理">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="editClassAdditionalMsg(scope.row,'KcFlagForm')"
							icon="el-icon-s-promotion" circle></el-button>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="上传日期"> </el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<el-switch slot="reference" v-model="scope.row.status == 0" active-color="#13ce66"
							inactive-color="var(--grey)" active-text="上架" inactive-text="下架"
							@change="changesale(scope.row.courseName,scope.row.courseId, scope.row.status)" />
					</template>
				</el-table-column>
				<el-table-column prop="status" label="操作" width="200">
					<template slot-scope="scope">
						<el-button size="mini" plain type="primary" @click="editClass(scope.row)">编辑</el-button>
						<el-button size="mini" plain type="primary" @click="chapterManager(scope.row)">章节管理</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total,prev, pager, next" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange">
			</el-pagination>
		</el-col>
		<el-col :span="24">
			<el-dialog title="课程管理" :visible.sync="classFormVisible" @close="closeclassform">
				<!-- Form表单区域 -->
				<el-form :model="classForm" :rules="classRules" ref="classForm" label-width="100px"
					class="demo-ruleForm">
					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="课程名称" prop="courseName">
								<el-input size="mini" v-model="classForm.courseName"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="课程阶段" prop="customerStage">
								<el-select filterable size="mini" v-model="classForm.customerStage"
									placeholder="请选择课程阶段">
									<el-option v-for="item in clasStageList" :key="item.dicId" :label="item.dicDesc"
										:value="item.dicId">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="课程讲师" prop="courseLecturer">
								<el-input size="mini" v-model="classForm.courseLecturer"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="主题图片" prop="themePic">
								<div style="display: flex;align-items: center;">
									<el-upload :action="uploadUrl" list-type="picture-card" :limit="1"
										accept=".jpg,.png,.jpeg,.mp4,.avi" :file-list="fileList"
										:on-success="getPictrueURL" :on-preview="handlePictureCardPreview"
										:on-error="handleError" :multiple="true" :on-exceed="handleOverImage">
										<i class="el-icon-plus"></i>
									</el-upload>
									<el-button @click="openImg" type="text" style="margin-left: 20px;">
										图片库上传
									</el-button>
								</div>
								<el-dialog append-to-body :visible.sync="dialogDisplay" @close="imagePrevClosed"
									size="tiny">
									<img width="100%" :src="dialogImageUrl" alt="">
								</el-dialog>

							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="关联品类" prop="category">
								<el-select filterable size="mini" v-model="classForm.category" placeholder="请选择关联品类">
									<el-option v-for="item in matVarietyList" :key="item.dicId" :label="item.dicDesc"
										:value="item.dicId">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="课程状态" prop="status">
						<el-switch v-model="classForm.status" active-color="#13ce66" inactive-color="var(--grey)"
							active-text="上架" inactive-text="下架" />
					</el-form-item>
					<el-form-item label="课程简介" prop="courseIntroduce">
						<el-input type="textarea" v-model="classForm.courseIntroduce"></el-input>
					</el-form-item>
					<el-form-item>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" type="primary" @click="submitForm('classForm')">确认</el-button>
					<el-button size="mini" @click="resetForm('classForm')">重置</el-button>
					<el-button size="mini" @click="switchDialog('classForm')">取 消</el-button>
				</div>
			</el-dialog>
		</el-col>
		<!-- 章节管理页面 -->
		<el-col :span="24">
			<el-drawer title="" :visible.sync="chapterDrawer" direction="btt" :before-close="closeChapterDrawer"
				size="93%">
				<el-row>
					<el-col :span="16" :offset="4">
						<el-button size="mini" type="primary" @click="openInner()">新增一个章节</el-button>
					</el-col>
					<el-col :span="16" :offset="4">
						<el-table :data="chapterDataList" stripe style="width: 100%">
							<el-table-column prop="chapterNo" label="章节编号" width="120">
							</el-table-column>
							<el-table-column prop="chapterTitle" label="章节标题" width="180">
							</el-table-column>
							<el-table-column prop="chapterSubtitle" label="副标题">
							</el-table-column>
							<el-table-column prop="chapterLength" label="时长">
							</el-table-column>
							<el-table-column prop="fileType" label="文件类型">
							</el-table-column>
							<el-table-column prop="status" label="状态">
								<template slot-scope="scope">
									<el-switch slot="reference" v-model="scope.row.status == 0" active-color="#13ce66"
										inactive-color="var(--grey)" active-text="上架" inactive-text="下架"
										@change="changeChaptersale(scope.row,'status')" />
								</template>
							</el-table-column>
							<el-table-column prop="status" label="试听">
								<template slot-scope="scope">
									<el-switch slot="reference" v-model="scope.row.freeTrial == 0"
										active-color="#13ce66" inactive-color="var(--grey)" active-text="可"
										inactive-text="不可" @change="changeChaptersale(scope.row,'freeTrial')" />
								</template>
							</el-table-column>
							<el-table-column prop="fileType" label="操作" width="245">
								<template slot-scope="scope">
									<el-button size="mini" plain type="primary" @click="editChapter(scope.row)">编辑
									</el-button>
									<el-button size="mini" plain type="primary" @click="caseClass(scope.row)">案例课
									</el-button>
									<el-button size="mini" plain type="primary" @click="taskExport(scope.row)">作业导出
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
					<el-col :span="16">
						<el-dialog title="作业导出" :visible.sync="dialogFormVisible" :append-to-body="true" width="32%">
							<el-form model="exportForm">
								<el-form-item label="学员期数">
									<el-input placeholder="请输入学员期数" v-model="exportForm.memberBatch">
									</el-input>
								</el-form-item>
								<el-form-item label="班长编号">
									<el-input placeholder="班长在商城的纯数字编号" v-model="exportForm.leaderMemberId">
									</el-input>
								</el-form-item>
							</el-form>
							<div slot="footer" class="dialog-footer">
								<el-button @click="dialogFormVisible = false">取 消</el-button>
								<el-button type="primary" @click="exportOut">确 定</el-button>
							</div>
						</el-dialog>
					</el-col>
					<el-drawer title="编辑/新增 章节" :append-to-body="true" :before-close="handleInnerClose"
						:visible.sync="chapterInnerDrawer" size="93%">
						<el-col :span="10">
							<!-- 增加修改课堂的form表单处 -->
							<el-form :model="chapterForm" :rules="chapterRules" ref="chapterForm" label-width="100px"
								class="demo-ruleForm">
								<el-row :gutter="20">
									<el-col :span="8">
										<el-form-item label="章节编号" prop="chapterNo">
											<el-input size="mini" v-model="chapterForm.chapterNo"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="章节标题" prop="chapterTitle">
											<el-input size="mini" v-model="chapterForm.chapterTitle"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="副标题" prop="chapterSubtitle">
											<el-input size="mini" v-model="chapterForm.chapterSubtitle"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="文章内容">
											<wangeditor v-model="chapterForm.chapterInfo" style="width:100%;margin:0;"
												ref="wangeditor" />
										</el-form-item>
									</el-col>
									<el-col :span="16">
										<el-form-item label="章节作业">
											<wangeditor v-model="chapterForm.chapterTask" style="width:100%;margin:0;"
												ref="wangeditor" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="章节封面">
											<el-upload :action="uploadUrl" list-type="picture-card" :limit="1"
												accept=".jpg,.png,.jpeg,.mp4,.avi" :file-list="chapterImageFile"
												:on-success="handleChapterFormImage" :on-error="handleError"
												:multiple="true" :on-exceed="handleOverImage">
												<i class="el-icon-plus"></i>
											</el-upload>
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="章节视频/音频">
											<el-upload :action="uploadUrl" list-type="picture-card" :limit="1"
												:file-list="chapterVideoFile" :on-success="handleChapterFormVideo"
												:on-error="handleError" :multiple="true" :on-exceed="handleOverImage">
												<i class="el-icon-plus"></i>
											</el-upload>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="音视频长度">
											<el-input size="mini" type="number" v-model="chapterForm.chapterLength">
											</el-input> 单位:秒
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="章节状态" prop="status">
											<el-switch v-model="chapterForm.status" active-color="#13ce66"
												inactive-color="var(--grey)" active-text="上架" inactive-text="下架" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-button size="mini" type="primary" @click="submitForm('chapterForm')">确认
										</el-button>
										<el-button size="mini" @click="switchDialog('chapterForm')">取 消</el-button>
									</el-col>
								</el-row>
							</el-form>
						</el-col>
					</el-drawer>

				</el-row>
			</el-drawer>
		</el-col>
		<!-- 标签管理 -->
		<el-col :span="24">
			<el-drawer title="" :visible.sync="dicDrawer" direction="rtl" :before-close="closDicDrawer" size="40%">
				<!-- Form表单区域 -->
				<el-form :model="dicForm" :rules="dicRules" ref="dicForm" label-width="100px" class="demo-ruleForm">
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item label="用户特性标签" prop="userAppealLabelsList">
								<el-checkbox-group v-model="dicForm.userAppealLabelsList">
									<el-checkbox class="el-col-2" v-for="item in userAppealLabelsList"
										:key="item.dicDesc" :label="item.dicId">
										{{item.dicDesc}}
									</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="用户诉求标签" prop="userTypeLabelsList">
								<el-checkbox-group v-model="dicForm.userTypeLabelsList">
									<el-checkbox class="el-col-4" v-for="item in userTypeLabelsList" :key="item.dicDesc"
										:label="item.dicId">
										{{item.dicDesc}}
									</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-button size="mini" type="primary" @click="submitForm('dicForm')">确认</el-button>
							<el-button size="mini" @click="resetForm('dicForm')">重置</el-button>
							<el-button size="mini" @click="switchDialog('dicForm')">取 消</el-button>
						</el-col>
					</el-row>
				</el-form>
			</el-drawer>
		</el-col>
		<!-- 分组标签处理~ -->
		<el-col :span="24">
			<el-dialog title="分组选择" :visible.sync="groupDicDrawer">
				<el-form :model="groupDicForm" ref="groupDicForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="当前操作">
						<div style="font-weight: 550;">{{groupDicForm.courseName}}</div>
					</el-form-item>
					<el-form-item label="选择分类">
						<el-radio-group v-model="GroupFatherId">
							<el-radio v-for="(item,index) in GroupFatherList" :key="index" :label="item.dicId">
								{{item.dicDesc}}
							</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="选择分组">
						<el-radio-group v-model="groupDicForm.groupFields">
							<el-radio v-for="item in GroupSunList[GroupFatherId]" :key="item" :label="item.dicId">
								{{item.dicDesc}}
							</el-radio>
						</el-radio-group>
					</el-form-item>

				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" type="primary" @click="submitForm('groupDicForm')">确 定</el-button>
					<el-button size="mini" @click="resetForm('groupDicForm')">重置</el-button>
					<el-button size="mini" @click="switchDialog('groupDicForm')">取 消</el-button>
				</div>
			</el-dialog>
		</el-col>
		<!-- 扩充标识管理~ -->
		<el-col :span="24">
			<el-dialog title="扩充标识管理" :visible.sync="kcLabelDrawer">
				<el-form :model="kcLabelForm" ref="kcLabelForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="当前操作">
						<div style="font-weight: 550;">{{kcLabelForm.courseName}}</div>
					</el-form-item>
					<el-form-item label="扩充标识操作">
						<el-tag :key="tag" v-for="tag in kcLabelForm.kcLabelList" closable :disable-transitions="false"
							@close="handleClose(tag)">
							{{tag}}
						</el-tag>
						<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
							size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
						</el-input>
						<el-button v-else class="button-new-tag" size="small" @click="showInput">+ 扩充标识</el-button>
					</el-form-item>

				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" type="primary" @click="submitForm('kcLabelForm')">确 定</el-button>
					<el-button size="mini" @click="resetForm('kcLabelForm')">重置</el-button>
					<el-button size="mini" @click="switchDialog('kcLabelForm')">取 消</el-button>
				</div>
			</el-dialog>
		</el-col>
		<!-- 扩充标签管理~ -->
		<el-col :span="24">
			<el-dialog title="扩充标签管理" :visible.sync="KcFlagDrawer">
				<el-form :model="KcFlagForm" ref="KcFlagForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="当前操作">
						<div style="font-weight: 500;">{{KcFlagForm.courseName}}</div>
					</el-form-item>
					<el-form-item label="扩充标签操作">
						<el-tag :key="tag.sid" v-for="tag in KcFlagForm.kcFlagList" closable
							:disable-transitions="false" @close="removeKcFlag(tag)">
							{{tag.fname}}->{{tag.sname}}
						</el-tag>
						<!-- 展示应有的扩充标签 -->
					</el-form-item>
					<el-form-item label="选择标签">
						<el-select size="mini" style="width:260px !important;" filterable v-model="KcFlagFatherIndex"
							placeholder="请选择大类标签" @change="KcFlagFatherChange()">
							<el-option v-for="(item,index) in KcFlagFatherList" :key="index" :label="item.dicDesc"
								:value="index">
							</el-option>
						</el-select>
						<i class="el-icon-d-arrow-right" style="padding:0 10px"></i>
						<el-select size="mini" style="width:260px !important;" filterable v-model="KcFlageSunIndex"
							placeholder="请选择类属标签">
							<el-option v-for="(item,index) in KcFlagSunList[KcFlagFatherId]" :key="index"
								:label="item.dicDesc" :value="index">
							</el-option>
						</el-select>
						<el-button type="primary" size="mini" style="margin-left:20px" @click="addKcFlag()">增加
						</el-button>
					</el-form-item>

				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" type="primary" @click="submitForm('KcFlagForm')">确 定</el-button>
					<el-button size="mini" @click="resetForm('KcFlagForm')">重置</el-button>
					<el-button size="mini" @click="switchDialog('KcFlagForm')">取 消</el-button>
				</div>
			</el-dialog>
		</el-col>
		<el-col>
			<el-drawer title="案例课" :visible.sync="caseTable" direction="rtl" size="80%">
				<el-table :data="caseData" stripe style="width: 100%">
					<el-table-column prop="chapterNo" label="章节编号" width="120">
					</el-table-column>
					<el-table-column prop="chapterTitle" label="章节标题" width="180">
					</el-table-column>
					<el-table-column prop="chapterSubtitle" label="副标题">
					</el-table-column>
					<el-table-column prop="chapterLength" label="时长">
					</el-table-column>
					<el-table-column prop="fileType" label="文件类型">
					</el-table-column>
					<el-table-column prop="status" label="状态">
						<template slot-scope="scope">
							<el-switch slot="reference" v-model="scope.row.status == 0" active-color="#13ce66"
								inactive-color="var(--grey)" active-text="上架" inactive-text="下架"
								@change="changeChaptersale(scope.row,'status')" />
						</template>
					</el-table-column>
					<el-table-column prop="status" label="试听">
						<template slot-scope="scope">
							<el-switch slot="reference" v-model="scope.row.freeTrial == 0" active-color="#13ce66"
								inactive-color="var(--grey)" active-text="可" inactive-text="不可"
								@change="changeChaptersale(scope.row,'freeTrial')" />
						</template>
					</el-table-column>
				</el-table>
			</el-drawer>
		</el-col>
		<el-drawer title="选择图片" :visible.sync="isShow" direction="rtl" size="40%">
			<SelectPicture :imgNum="1" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>
<script>
	import httpClient from '../../../util/request.js';
	import wangeditor from '../../../components/wangEditor/wangEditor.vue';
	// import func from '../../../../vue-temp/vue-editor-bridge';
	import SelectPicture from '../../../components/SelectPicture/index.vue'
	export default {
		components: {
			wangeditor,
			SelectPicture
		},
		data() {
			return {
				radio: 1,
				isSelectPicture: false,
				// 分页组件
				pageNum: 1,
				pageSize: 15,
				total: null,
				// table 自适应高度
				tableHeight: window.innerHeight - 300,
				classStatus: [{
					label: '全部',
					value: ''
				}, {
					label: '上架',
					value: '0'
				}, {
					label: '下架',
					value: '1'
				}],
				uploadUrl: httpClient.imgUrl,
				fileList: [], // 商品图片上传控件图片数据源
				dialogDisplay: false, // 上传图片弹窗
				dialogImageUrl: '', //上传图片控件预览url
				classData: [],
				// 课程查询条件
				coursename: '',
				status: '',
				category: '',
				// 标签组
				userAppealLabelsList: [],
				userTypeLabelsList: [],
				matVarietyList: [],
				classIdList: [],
				clasStageList: [],
				// 课程表单操作
				classFormVisible: false,
				classForm: {
					courseId: '',
					courseName: '',
					customerStage: '',
					status: true,
					category: '',
					resource: '',
					courseIntroduce: '',
					courseLecturer: '',
					themePic: ''
				},
				// 课程表单验证
				classRules: {
					courseName: [{
							required: true,
							message: '请输入课程名称',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 15,
							message: '长度在 3 到 15 个字符',
							trigger: 'blur'
						}
					],
					customerStage: [{
						required: true,
						message: '请选择课程阶段',
						trigger: 'change'
					}],
					category: [{
						required: true,
						message: '请选择关联品类',
						trigger: 'change'
					}],
					resource: [{
						required: true,
						message: '请选择活动资源',
						trigger: 'change'
					}],
					courseIntroduce: [{
							required: true,
							message: '请填写课程简介',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 35,
							message: '长度在 3 到 35 个字符',
							trigger: 'blur'
						}
					],
					courseLecturer: [{
							required: true,
							message: '请填写课程讲师',
							trigger: 'blur'
						},
						{
							min: 2,
							max: 10,
							message: '长度在 2 到 10 个字符',
							trigger: 'blur'
						}
					],
					themePic: [{
						required: true,
						message: '请上传主题图片',
						trigger: 'blur'
					}]
				},
				//案例课
				caseTable: false,
				caseData: '',
				caseForm: {
					chapterId: '',
					parentId: '',
					chapterNo: '',
					courseId: '',
					chapterTitle: '',
					chapterSubtitle: '',
					chapterInfo: '',
					chapterTask: '',
					fileType: '',
					chapterVideo: '',
					chapterPic: '',
					chapterLength: 0,
					createTime: '',
					status: true
				},
				// 章节的操作数据
				// 章节的增改
				chapterInnerDrawer: false,
				chapterDrawer: false,
				isClear: true,
				chapterDataList: [],
				chapterImageFile: [],
				chapterVideoFile: [],
				chapterForm: {
					chapterId: '',
					chapterNo: '',
					courseId: '',
					chapterTitle: '',
					chapterSubtitle: '',
					chapterInfo: '',
					chapterTask: '',
					fileType: '',
					chapterVideo: '',
					chapterPic: '',
					chapterLength: 0,
					createTime: '',
					status: true
				},
				chapterRules: {
					chapterNo: [{
						required: true,
						message: '请填写章节编号',
						trigger: 'blur'
					}],
					chapterTitle: [{
						required: true,
						message: '请填写章节标题',
						trigger: 'blur'
					}],
					chapterSubtitle: [{
						required: true,
						message: '请填写文章副标题',
						trigger: 'blur'
					}],
					chapterInfo: [{
						required: true,
						message: '请填写章节详情',
						trigger: 'blur'
					}],
					chapterVideo: [{
						required: true,
						message: '请上传视频/音频文件',
						trigger: 'blur'
					}],
					chapterPic: [{
						required: true,
						message: '请上传章节图片',
						trigger: 'blur'
					}],
					chapterLength: [{
						required: true,
						message: '时长不能为空',
						trigger: 'blur'
					}],

				},
				//课程标签处理
				dicDrawer: false,
				dicForm: {
					// 两种多选标签
					courseId: '',
					userAppealLabelsList: [],
					userTypeLabelsList: []
				},
				dicRules: {
					userAppealLabelsList: [{
						type: 'array',
						required: true,
						message: '请至少选择一个用户特征标签',
						trigger: 'change'
					}],
					userTypeLabelsList: [{
						type: 'array',
						required: true,
						message: '请至少选择一个用户诉求标签',
						trigger: 'change'
					}]
				},
				// 课程分组标签的处理
				groupDicDrawer: false,
				groupDicForm: {
					courseId: '',
					courseName: '',
					groupFields: 0
				},
				GroupFatherId: 0,
				GroupFatherList: [],
				GroupSunList: {},
				// 扩充标识管理
				kcLabelDrawer: false,
				kcLabelForm: {
					courseId: '',
					kcLabel: '',
					courseName: '',
					kcLabelList: []
				},
				inputVisible: false,
				inputValue: '',
				//作业导出
				dialogFormVisible: false,
				exportForm: {
					chapterId: '',
					memberBatch: '',
					leaderMemberId: '',
				},
				classId: '',
				className: '',
				// 课程扩充标签
				KcFlagFatherList: [],
				KcFlagSunList: {},
				KcFlagDrawer: false,
				KcFlagForm: {
					courseId: '',
					kcFlag: '',
					courseName: '',
					kcFlagList: []
				},
				KcFlagFatherId: null,
				KcFlagFatherIndex: null,
				KcFlageSunIndex: null
			}
		},
		created() {
			this.query();
			this.getMatDic();
			this.getGroupFatherList(-1, '课程分组', '课程分组');
			this.getGroupFatherList(-1, '课程扩充', '课程扩充');
			console.log(httpClient);
		},
		methods: {
			openImg() {
				this.isShow = true
			},
			getImg(e) {
				console.log(e);
				this.fileList = []
				this.classForm.themePic = ''
				this.classForm.themePic = e
				this.fileList.push({
					url: e
				})
				this.isShow = false
				console.log(this.classForm.themePic);
			},
			// 打开操作标签的页面
			openDicDrawer() {
				this.dicDrawer = true
			},
			// 打开章节操作的页面
			openChapterDrawer() {
				this.chapterDrawer = true
			},
			closeChapterDrawer() {
				this.chapterDrawer = false
				this.dicDrawer = false
			},
			closDicDrawer() {
				this.resetForm('dicForm')
				this.chapterDrawer = false
				this.dicDrawer = false
			},
			// 课程扩充信息编辑区域
			editClassAdditionalMsg(row, type) {
				this.switchDialog(type);
				setTimeout(() => {
					if (type == 'groupDicForm') {
						this.groupDicForm.courseId = row.courseId;
						this.groupDicForm.courseName = row.courseName;
						this.groupDicForm.groupFields = row.groupFields;
						for (let key in this.GroupSunList) {
							if (this.GroupSunList[key]) {
								this.GroupSunList[key].forEach(element => {
									if (element.dicId == row.groupFields) {
										this.GroupFatherId = parseInt(key);
									}
								})
							}
						}
					}
					if (type == 'kcLabelForm') {
						this.kcLabelForm.courseId = row.courseId;
						this.kcLabelForm.courseName = row.courseName;
						this.kcLabelForm.kcLabel = "";
						this.kcLabelForm.kcLabelList = [];
						if (row.kcLabel) {
							this.kcLabelForm.kcLabel = row.kcLabel;
							this.kcLabelForm.kcLabelList = row.kcLabel.split(",");
						}
					}
					if (type == 'dicForm') {
						if (row.valuelist) {
							for (var i = 0; i < row.valuelist.length; i++) {
								var item = row.valuelist[i];
								this.dicForm.userAppealLabelsList.push(parseInt(item));
							}
						}
						if (row.typelist) {
							for (var i = 0; i < row.typelist.length; i++) {
								var item = row.typelist[i];
								this.dicForm.userTypeLabelsList.push(parseInt(item));
							}
						}
						this.dicForm.courseId = row.courseId;
					}
					if (type == 'KcFlagForm') {
						// 扩充标签准备用  JSONARRAY的形式来存  放到数据库里面转成字符串来存。
						this.KcFlagForm.courseId = row.courseId;
						this.KcFlagForm.courseName = row.courseName;
						this.KcFlagForm.kcFlag = "";
						this.KcFlagForm.kcFlagList = [];
						if (row.kcFlag) {
							this.KcFlagForm.kcFlag = row.kcFlag;
							this.KcFlagForm.kcFlagList = JSON.parse(row.kcFlag);
						}
					}
				}, 500);
			},
			// 扩充标签的方法
			KcFlagFatherChange() {
				console.log(this.KcFlagFatherIndex);
				this.KcFlagFatherId = this.KcFlagFatherList[this.KcFlagFatherIndex].dicId;
			},
			removeKcFlag(tag) {
				this.KcFlagForm.kcFlagList.splice(this.KcFlagForm.kcFlagList.indexOf(tag), 1);
				this.KcFlagForm.kcFlag = JSON.stringify(this.KcFlagForm.kcFlagList);
			},
			addKcFlag() {
				// 增加Flag
				if (this.KcFlagFatherIndex == null || this.KcFlagFatherId == null || this.KcFlageSunIndex == null) {
					this.$message.error('请选择标签~');
					return;
				}
				// 组装数据并填充。
				let Fitem = this.KcFlagFatherList[this.KcFlagFatherIndex];
				let Sitem = (this.KcFlagSunList[this.KcFlagFatherId])[this.KcFlageSunIndex];
				let meNow = {
					fid: Fitem.dicId,
					fname: Fitem.dicDesc,
					sid: Sitem.dicId,
					sname: Sitem.dicDesc
				};
				this.KcFlagForm.kcFlagList.push(meNow);
				this.KcFlagForm.kcFlag = JSON.stringify(this.KcFlagForm.kcFlagList);
			},
			// 扩充标识的点击方法
			handleClose(tag) {
				this.kcLabelForm.kcLabelList.splice(this.kcLabelForm.kcLabelList.indexOf(tag), 1);
				this.resetKcLabel();
			},
			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},
			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.kcLabelForm.kcLabelList.push(inputValue);
					this.resetKcLabel();
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			// 重新整理对应的标签
			resetKcLabel() {
				if (this.kcLabelForm.kcLabelList.length > 0) {
					let kcLabel = '';
					this.kcLabelForm.kcLabelList.forEach(element => {
						kcLabel = kcLabel + ',' + element;
					})
					if (kcLabel != '') {
						kcLabel = kcLabel.substr(1);
					}
					this.kcLabelForm.kcLabel = kcLabel;
					console.log(this.kcLabelForm.kcLabel)
				}
			},
			// 请求标签信息
			getMatDic() {
				// 标签备注 1-用户特征,2-用户诉求,3-品类, 4-图片素材类型，5-文章素材类型,7-素材维度,7-营销阶段,8-佩戴方式，9-内容类型，10-设计师，11-石头类型，12-课程阶段标签  
				var dicTypeS = [1, 2, 3, 12];
				var dicTypeValue = {
					1: 180,
					2: 179,
					3: 181,
					12: 189
				};
				dicTypeS.forEach(element => {
					this.$http.get('/api/source/matDic/selectByParentId?pid=' + dicTypeValue[element], {}).then(
						res => {
							switch (element) {
								case 1:
									this.userAppealLabelsList = res.data.data;
									break;
								case 2:
									this.userTypeLabelsList = res.data.data;
									break;
								case 3:
									this.matVarietyList = res.data.data;
									break;
								case 12:
									this.clasStageList = res.data.data;
									break;
							}
						}).finally(res => {});
				});
			},
			// 获取基础的标签 课程分组标签的信息
			getGroupFatherList(pid, dicMatValue, type) {
				var url = '/api/source/matDic/selectByParentId?pid=' + pid;
				if (dicMatValue) {
					url = url + "&dicMatValue=" + dicMatValue;
				}
				this.$http.get(url, {}).then(res => {
					if (pid == -1) {
						if (type == '课程分组') {
							this.GroupFatherList = res.data.data;
							this.findGroupSunList(this.GroupFatherList, type);
						}
						if (type == '课程扩充') {
							this.KcFlagFatherList = res.data.data;
							this.findGroupSunList(this.KcFlagFatherList, type);
						}
					} else {
						if (type == '课程分组') {
							this.GroupSunList[pid] = res.data.data;
						}
						if (type == '课程扩充') {
							this.KcFlagSunList[pid] = res.data.data;
						}
					}
				}).finally(res => {});
			},
			// getSUN
			findGroupSunList(GroupFatherList, type) {
				GroupFatherList.forEach(element => {
					this.getGroupFatherList(element.dicId, null, type);
				})
			},
			getValue(array, key, value, key2) {
				var currentValue;
				for (var i = 0; i < array.length; i++) {
					var textvalue = array[i][key];
					if (textvalue == value) {
						currentValue = array[i][key2];
					}
				}
				return currentValue;
			},

			// 编辑课程基本信息
			editClass(row) {
				this.switchDialog('classForm');
				setTimeout(() => {
					this.classForm.courseId = row.courseId;
					this.classForm.courseName = row.courseName;
					var customerStage = this.getValue(this.clasStageList, 'dicId', row.customerStage, 'dicId');
					this.classForm.customerStage = customerStage;
					this.classForm.courseLecturer = row.courseLecturer;
					this.classForm.themePic = row.themePic;
					this.fileList.push({
						url: row.themePic
					});
					var category = this.getValue(this.matVarietyList, 'dicId', row.category, 'dicId');
					this.classForm.category = category;
					this.classForm.courseIntroduce = row.courseIntroduce;
					this.classForm.status = row.status == 0 ? true : false;
				}, 500);
			},
			chapterManager(row) {
				this.chapterDataList = [];
				this.switchDialog('chapterForm');
				setTimeout(() => {
					var courseId = row.courseId;
					this.chapterForm.courseId = row.courseId;
					this.queryChapter(courseId);
				}, 500);
			},
			editChapter(row) {
				this.chapterForm.chapterId = '';
				this.chapterForm.chapterInfo = '';
				this.chapterForm.chapterTask = '';
				this.chapterInnerDrawer = true;
				var that = this;
				setTimeout(function() {
					// that.$refs.wangeditor.clearText();
					that.chapterForm.chapterId = row.chapterId;
					that.chapterForm.chapterNo = row.chapterNo;
					that.chapterForm.chapterTitle = row.chapterTitle;
					that.chapterForm.chapterSubtitle = row.chapterSubtitle;
					that.chapterForm.chapterInfo = row.chapterInfo;
					that.chapterForm.chapterTask = row.chapterTask;
					that.chapterForm.fileType = row.fileType;
					that.chapterVideoFile.push({
						url: row.chapterVideo
					});
					that.chapterForm.chapterVideo = row.chapterVideo;
					that.chapterImageFile.push({
						url: row.chapterPic
					});
					that.chapterForm.chapterPic = row.chapterPic;
					that.chapterForm.chapterLength = row.chapterLength;
					that.chapterForm.status = row.status == 0 ? true : false;
					console.log("编辑章节", that.chapterForm);
				}, 500)
			},
			//作业导出系列之组装参数；
			taskExport(row) {
				this.dialogFormVisible = true;
				var that = this;
				setTimeout(function() {
					that.exportForm.chapterId = row.chapterId;
					that.exportForm.memberBatch = this.exportForm.memberBatch;
					that.exportForm.leaderMemberId = this.exportForm.leaderMemberId;
				}, 500)
			},
			//作业导出系列之确认导出
			exportOut() {
				this.$http.post('/api/source/clrChapterTask/export', this.exportForm, {
					responseType: 'blob'
				}).then(res => {
					this.$message("正在导出EXCEL表格");
					this.dialogFormVisible = false;
					const blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel;'
					})
					const fileName = '学员作业.xlsx';
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = window.URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					window.URL.revokeObjectURL(elink.href);
					document.body.removeChild(elink);
				});
			},
			//相关案例课
			caseClass(row) {
				this.caseTable = true;

				this.$http.post('/api/source/clrCourseChapter/listPage?pageNum=&pageSize=', {
					parentId: row.chapterId
				}).then(res => {
					this.caseData = res.data.data.list
				});
			},
			chapterManager(row) {
				this.chapterDataList = [];
				this.switchDialog('chapterForm');
				setTimeout(() => {
					var courseId = row.courseId;
					this.chapterForm.courseId = row.courseId;
					this.queryChapter(courseId);
				}, 500);
			},

			changeChaptersale(row, type) {
				if (type == 'status') {
					var status = row.status == 0 ? 1 : 0;
					var chapterTitle = row.chapterTitle;
					this.$http.post('/api/source/clrCourseChapter/updateStatus?pk=' + row.chapterId + '&status=' +
						status, {}).then(res => {
						if (res.data.status == 0) {
							var statusText = status != 0 ? '下架' : '上架';
							if (status != 0) {
								this.$message.error(chapterTitle + "已" + statusText);
							} else {
								this.$message.success(chapterTitle + "已" + statusText);
							}
							this.queryChapter(this.chapterForm.courseId);
						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
					});
				}
				if (type == 'freeTrial') {
					var freeTrial = row.freeTrial == 0 ? 1 : 0;
					var chapterTitle = row.chapterTitle;
					this.$http.post('/api/source/clrCourseChapter/update?', {
						chapterId: row.chapterId,
						freeTrial: freeTrial
					}).then(res => {
						if (res.data.status == 0) {
							var statusText = freeTrial != 0 ? '不可' : '可';
							if (freeTrial != 0) {
								this.$message.error(chapterTitle + "已" + statusText);
							} else {
								this.$message.success(chapterTitle + "已" + statusText);
							}
							this.queryChapter(this.chapterForm.courseId);
						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
					});
				}
			},

			queryChapter(courseId) {
				this.$http.post('/api/source/clrCourseChapter/listPage?pageNum=&pageSize=', {
					courseId: courseId
				}).then(res => {
					console.log(res);
					this.chapterDataList = res.data.data.list;
				}).finally(res => {});
			},

			// Form表单提交，可以通过不同的 formName 来区别提交
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(valid)
						switch (formName) {
							case 'classForm':
								console.log(this.classForm);
								var classform = this.classForm;
								if (classform.status) {
									classform.status = 0;
								} else {
									classform.status = 1;
								}
								this.$http.post('/api/source/clrCourse/add', this.classForm).then(res => {
									if (res.data.status == 0) {
										this.$message.success('操作成功');
										this.switchDialog(formName);
									} else {
										this.$message.error(res.data.msg);
									}
									this.query();
								}).finally(res => {});
								break;
							case 'chapterForm':
								console.log(this.chapterForm);
								var chapterform = this.chapterForm;
								if (chapterform.status) {
									chapterform.status = 0;
								} else {
									chapterform.status = 1;
								}
								this.$http.post('/api/source/clrCourseChapter/add', this.chapterForm).then(res => {
									if (res.data.status == 0) {
										this.$message.success('操作成功');
									} else {
										this.$message.error(res.data.msg);
									}
									this.queryChapter(this.chapterForm.courseId);
									this.handleInnerClose();
								}).finally(res => {});
								break;
							case 'dicForm':
								console.log(this.dicForm.userTypeLabelsList);
								console.log(this.dicForm.userAppealLabelsList);
								this.$http.post('/api/source/clrCourse/bindLabel', {
									courseId: this.dicForm.courseId,
									typelist: this.dicForm.userTypeLabelsList,
									valuelist: this.dicForm.userAppealLabelsList
								}).then(res => {
									if (res.data.status == 0) {
										this.$message.success('绑定成功');
										this.switchDialog(formName);
									} else {
										this.$message.error(res.data.msg);
									}
									this.query();
								}).finally(res => {});
								break;
							case 'groupDicForm':
								this.$http.post('/api/source/clrCourse/update', this.groupDicForm).then(res => {
									if (res.data.status == 0) {
										this.$message.success('分组成功');
										this.switchDialog(formName);
									} else {
										this.$message.error(res.data.msg);
									}
									this.query();
								}).finally(res => {});
								break;
							case 'kcLabelForm':
								this.$http.post('/api/source/clrCourse/update', this.kcLabelForm).then(res => {
									if (res.data.status == 0) {
										this.$message.success('扩充成功');
										this.switchDialog(formName);
									} else {
										this.$message.error(res.data.msg);
									}
									this.query();
								}).finally(res => {});
								break;
							case 'KcFlagForm':
								this.$http.post('/api/source/clrCourse/update', this.KcFlagForm).then(res => {
									if (res.data.status == 0) {
										this.$message.success('增加标签成功');
										this.switchDialog(formName);
									} else {
										this.$message.error(res.data.msg);
									}
									this.query();
								}).finally(res => {});
								break;
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},

			closeclassform() {
				this.resetForm('classForm')
			},
			// 打开新增
			openInner() {
				this.chapterForm.chapterId = '';
				this.chapterForm.chapterInfo = '';
				this.chapterInnerDrawer = true;
				var that = this;
				setTimeout(function() {
					that.resetForm('chapterForm');
				}, 800)
			},
			handleInnerClose() {
				// 关闭对应的
				this.resetForm('chapterForm');
				this.chapterForm.chapterId = '';
				this.chapterInnerDrawer = false;
			},
			// 切换显示
			switchDialog(FormVisible, row) {
				switch (FormVisible) {
					case 'classForm':
						this.classFormVisible = !this.classFormVisible;
						if (this.classFormVisible) {
							this.resetForm(FormVisible)
						}
						break;
					case 'chapterForm':
						this.chapterForm.chapterId = '';
						this.chapterDrawer = !this.chapterDrawer;
						if (this.chapterDrawer) {
							setTimeout(() => {
								this.resetForm(FormVisible)
							}, 100);
						}
						break;
					case 'dicForm':
						this.dicDrawer = !this.dicDrawer;
						if (this.dicDrawer) {
							setTimeout(() => {
								this.resetForm(FormVisible)
							}, 100);
						}
						break;
					case 'groupDicForm':
						this.groupDicDrawer = !this.groupDicDrawer;
						if (this.groupDicDrawer) {
							setTimeout(() => {
								this.resetForm(FormVisible)
							}, 100);
						}
						break;
					case 'kcLabelForm':
						this.kcLabelDrawer = !this.kcLabelDrawer;
						if (this.kcLabelDrawer) {
							setTimeout(() => {
								this.resetForm(FormVisible)
							}, 100);
						}
						break;
					case 'KcFlagForm':
						this.KcFlagDrawer = !this.KcFlagDrawer;
						if (this.KcFlagDrawer) {
							setTimeout(() => {
								this.resetForm(FormVisible)
							}, 100);
						}
						break;

				}
			},
			resetForm(formName) {
				if (this.$refs[formName]) {
					this.$refs[formName].resetFields();
				}
				this.fileList = [];
				this.chapterImageFile = [];
				this.chapterVideoFile = [];
				this.dicForm.userAppealLabelsList = [];
				this.dicForm.userTypeLabelsList = [];
				this.dicForm.courseId = '';
			},
			// 根据上下架状态变换数据背景颜色
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (row.status == 0) {
					return 'low-row';
				}
				return 'up-row';
			},
			// 查询课程列表数据
			query() {
				var coursename = this.coursename;
				var category = this.category;
				var status = this.status;
				this.$http.post('/api/source/clrCourse/listPage?pageNum=' + this.pageNum + '&pageSize=' + this.pageSize, {
					courseName: coursename,
					status: status,
					category: category
				}).then(res => {
					console.log(res)
					this.classData = res.data.data.list;
					this.total = res.data.data.total;
				});
			},
			//切换课程上下架
			changesale(courseName, id, status) {
				status = status == 0 ? 1 : 0;
				this.$http.post('/api/source/clrCourse/updateStatus?pk=' + id + '&status=' + status, {}).then(res => {
					if (res.data.status == 0) {
						var statusText = status != 0 ? '下架' : '上架';
						if (status != 0) {
							this.$message.error(courseName + "已" + statusText);
						} else {
							this.$message.success(courseName + "已" + statusText);
						}
						this.query();
					} else {
						this.$message.error("发生未可知错误，请联系开发人员");
					}
				});
			},
			// 图片预览
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogDisplay = true;
			},
			// 图片预览dialog关闭时的回调
			imagePrevClosed() {
				this.dialogImageUrl = ''
			},
			getPictrueURL(response, file, fileList) {
				this.classForm.themePic = response.data;
			},
			handleChapterFormImage(response, file, fileList) {
				this.chapterForm.chapterPic = response.data;
			},
			handleChapterFormVideo(response, file, fileList) {
				console.log(response);
				console.log(file);
				console.log(fileList);
				this.chapterForm.chapterVideo = response.data;
				this.chapterForm.fileType = file.raw.type;


				var url = URL.createObjectURL(file.raw);
				var audioElement = new Audio(url);
				var duration;
				var _this = this;
				audioElement.addEventListener("loadedmetadata", function(_event) {
					duration = audioElement.duration; //时长为秒，小数，182.36
					_this.chapterForm.chapterLength = duration
				});

			},
			handleOverImage(files, fileList) {
				this.$message.error("已超出最大上传数量限制");
			},
			// 分页组件
			handleSizeChange(val) {
				this.pageNum = 1;
				this.query();
			},
			handleCurrentChange(val) {
				this.pageNum = val;
				this.query();
			},
			handleError(err, file, fileList) {
				err = err + "a";
				if (err.search("413") != -1) {
					this.$message.error("抱歉，文件过大，无法上传");
				} else {
					this.$message.error("抱歉，上传文件失败，请稍等片刻再次尝试");
				}
			}
		}
	}
</script>
<style lang="less" scoped>
	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}

	/deep/.el-input {
		// width: auto;
	}

	/deep/.el-input {
		height: auto;
	}
</style>
